import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <div className="py-4 border-b bg-white shadow-sm mb-8">
        <div className="container mx-auto px-4">
          <h1 className="text-2xl font-bold text-primary">Finnewsy</h1>
        </div>
      </div>
      
      <div className="flex-1 flex items-center justify-center">
        <div className="max-w-md w-full mx-4">
          <Outlet />
        </div>
      </div>
      
      <footer className="mt-auto py-4 border-t bg-white">
        <div className="container mx-auto px-4 text-center text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} Finnewsy. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout; 